var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 23.3332V20.9998C15.1667 17.7782 12.555 15.1665 9.33333 15.1665C6.11167 15.1665 3.5 17.7782 3.5 20.9998V23.3332H15.1667ZM15.1667 23.3332H24.5V22.1665C24.5 18.7301 21.8883 16.3332 18.6667 16.3332C17.0178 16.3332 15.5287 17.0629 14.4678 18.2361M12.8333 8.1665C12.8333 10.0995 11.2663 11.6665 9.33333 11.6665C7.40034 11.6665 5.83333 10.0995 5.83333 8.1665C5.83333 6.23351 7.40034 4.6665 9.33333 4.6665C11.2663 4.6665 12.8333 6.23351 12.8333 8.1665ZM21 10.4998C21 11.7885 19.9553 12.8332 18.6667 12.8332C17.378 12.8332 16.3333 11.7885 16.3333 10.4998C16.3333 9.21117 17.378 8.1665 18.6667 8.1665C19.9553 8.1665 21 9.21117 21 10.4998Z",
    stroke: "#C4C3FA",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.d617aa32eadbb5e988b6e075343765ca.svg";
export { ForwardRef as ReactComponent };